import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const STORAGE_KEY = "papicoo_lang";

const fr = {
  nav: {
    accueil: "Accueil", services: "Services", gp: "GP Sénégal", transfert: "Transfert",
    boutique: "Boutique", chat: "Chat", live: "Live", studio: "Studio", portrait: "Portrait",
    evoto: "Évoto", decodeur: "Décodeur", analyse: "Analyse", facebook: "Facebook",
    contrats: "Contrats", coran: "Coran", reseaux: "Mes Réseaux", papicoo: "Papicoo",
    cta: "Parler à Papicoo",
  },
  landing: {
    role: "DIRECTEUR ARTISTIQUE · PHOTOGRAPHE · WEB DESIGNER · MAQUETTISTE",
    title1: "Papicoo.",
    title2: "Le conseiller de la jeunesse.",
    intro: "Présent, juste, ancré dans le Coran. Analyste géopolitique et scientifique, conseiller en développement de projets, agence de communication, GP & transfert pour la diaspora — sans propagande, sans arnaque, dans toutes les langues.",
    cta1: "Commencer une conversation",
    cta2: "Qui est Papicoo ?",
    privacy: "Vie privée protégée — aucun mot de passe demandé, jamais.",
    forceTranquille: "FORCE TRANQUILLE",
    quote: "« Je ne suis que ce que les prophètes ont suivi. »",
  },
  switcher: { label: "Langue", fr: "Français", en: "English", ar: "العربية", wo: "Wolof" },
  verset: {
    eyebrow: "VERSET DU JOUR · PAPICOO",
    today: "Aujourd'hui",
    refresh: "Recharger",
    listen: "Écouter Papicoo lire (voix radio FM)",
    listening: "Pause",
    preparing: "Préparation studio…",
    download: "Télécharger l'image carrée (1080×1080)",
    share: "Partage cette baraka",
    surah: "Sourate",
    verse: "verset",
    tomorrow: "Reviens demain pour un nouveau verset 🌹",
    loading: "Chargement du verset…",
    title1: "Une lumière par jour.",
    title2: "À partager, à méditer.",
    intro: "Chaque jour, un nouveau verset du Coran — le même pour tout le monde ce jour-là. Télécharge l'image carrée et partage-la en story Instagram, WhatsApp ou X.",
  },
  ramadan: {
    eyebrow: "RAMADAN 1447H · CALENDRIER PAPICOO",
    title1: "30 lumières.",
    title2: "Un verset chaque jour.",
    intro: "Sélection coranique progressive — décade par décade — pour traverser le mois béni avec lucidité et douceur. Partage le verset du jour, télécharge l'image carrée, et offre la baraka autour de toi.",
    today: "Aujourd'hui · Jour {{day}} de Ramadan",
    loading: "Chargement du calendrier…",
    decade1: "Décade 1 · Miséricorde (Rahma)",
    decade2: "Décade 2 · Pardon (Maghfira)",
    decade3: "Décade 3 · Libération du feu (Itq min an-Nâr)",
    day: "Jour",
    image: "Image 1080×1080",
    listen: "Écouter Papicoo lire (voix radio FM)",
    listening: "Pause",
    preparing: "Préparation studio…",
  },
  coran: {
    eyebrow: "BIBLIOTHÈQUE CORANIQUE",
    title: "Le Coran, Hafs.",
    subtitle: "114 sourates · 6236 versets — texte FR + recherche plein texte.",
    search: "Rechercher un mot, un thème, un verset…",
  },
  chat: {
    welcome: "Salaam, muslim. Je suis Papicoo. Pose-moi ta question — réponse calme, ancrée dans le Coran.",
    placeholder: "Écris ton message à Papicoo…",
    send: "Envoyer",
    new: "Nouvelle discussion",
    free: "Questions gratuites",
    paywallTitle: "Tu as utilisé tes 3 questions offertes.",
    paywallBody: "Pour continuer à discuter avec Papicoo, débloque l'accès illimité.",
    paywallCta: "Débloquer l'accès",
    starter1: "As-salâmu ‘alaykum Papicoo, par quoi je commence pour gagner ma vie en restant droit ?",
    starter2: "Comment professionnaliser mon profil Facebook ?",
    starter3: "Donne-moi un verset sur la justice et explique-le simplement.",
    starter4: "Comment réveiller les consciences sans heurter ?",
  },
  footer: {
    intro: "Directeur Artistique · Photographe · Web Designer · Maquettiste — Paris. Le conseiller que la jeunesse sénégalaise n'a jamais eu.",
    secTitle: "Sécurité & vie privée",
    secBody: "Papicoo ne demande jamais vos mots de passe ni vos données sensibles. Vos conversations restent dans votre espace.",
    signature: "Design by Papicoo",
    privacy: "Confidentialité",
    cgu: "CGU",
    library: "Bibliothèque Coran",
  },
  meta: {
    title: "Papicoo — La force tranquille · Assistant IA & services",
    description: "Papicoo : assistant IA inspiré de Papicoo, services diaspora, studio de contenu, Coran et musique. Paris — Dakar — Le Monde.",
  },
  partial: "",
};

const en = {
  nav: {
    accueil: "Home", services: "Services", gp: "GP Senegal", transfert: "Transfer",
    boutique: "Shop", chat: "Chat", live: "Live", studio: "Studio", portrait: "Portrait",
    evoto: "Évoto", decodeur: "Decoder", analyse: "Analysis", facebook: "Facebook",
    contrats: "Contracts", coran: "Quran", reseaux: "My Networks", papicoo: "Papicoo",
    cta: "Talk to Papicoo",
  },
  landing: {
    role: "ART DIRECTOR · PHOTOGRAPHER · WEB DESIGNER · LAYOUT ARTIST",
    title1: "Papicoo.",
    title2: "The youth's adviser.",
    intro: "Present, fair, rooted in the Quran. Geopolitical and scientific analyst, project development adviser, communication agency, GP & transfer for the diaspora — no propaganda, no scams, in every language.",
    cta1: "Start a conversation",
    cta2: "Who is Papicoo?",
    privacy: "Privacy protected — no password ever requested.",
    forceTranquille: "QUIET STRENGTH",
    quote: "« I am only what the prophets followed. »",
  },
  switcher: { label: "Language", fr: "Français", en: "English", ar: "العربية", wo: "Wolof" },
  verset: {
    eyebrow: "VERSE OF THE DAY · PAPICOO",
    today: "Today",
    refresh: "Reload",
    listen: "Listen to Papicoo read (FM radio voice)",
    listening: "Pause",
    preparing: "Studio preparation…",
    download: "Download the square image (1080×1080)",
    share: "Share this baraka",
    surah: "Surah",
    verse: "verse",
    tomorrow: "Come back tomorrow for a new verse 🌹",
    loading: "Loading the verse…",
    title1: "One light a day.",
    title2: "To share, to reflect on.",
    intro: "Every day, a new verse of the Quran — the same for everyone that day. Download the square image and share it in your Instagram, WhatsApp or X stories.",
  },
  ramadan: {
    eyebrow: "RAMADAN 1447H · PAPICOO CALENDAR",
    title1: "30 lights.",
    title2: "One verse every day.",
    intro: "A progressive Quranic selection — decade by decade — to go through the blessed month with clarity and gentleness. Share the verse of the day, download the square image, and spread the baraka around you.",
    today: "Today · Day {{day}} of Ramadan",
    loading: "Loading the calendar…",
    decade1: "Decade 1 · Mercy (Rahma)",
    decade2: "Decade 2 · Forgiveness (Maghfira)",
    decade3: "Decade 3 · Liberation from the fire (Itq min an-Nâr)",
    day: "Day",
    image: "1080×1080 image",
    listen: "Listen to Papicoo read (FM radio voice)",
    listening: "Pause",
    preparing: "Studio preparation…",
  },
  coran: {
    eyebrow: "QURANIC LIBRARY",
    title: "The Quran, Hafs.",
    subtitle: "114 surahs · 6,236 verses — French text + full-text search.",
    search: "Search a word, a theme, a verse…",
  },
  chat: {
    welcome: "Salaam. I'm Papicoo's AI assistant. Ask me your question — a calm answer, rooted in the Quran.",
    placeholder: "Write your message to Papicoo…",
    send: "Send",
    new: "New discussion",
    free: "Free questions",
    paywallTitle: "You have used your 3 free questions.",
    paywallBody: "To keep talking with Papicoo, unlock unlimited access.",
    paywallCta: "Unlock access",
    starter1: "As-salâmu ‘alaykum Papicoo, where do I start to earn a living while staying upright?",
    starter2: "How can I make my Facebook profile more professional?",
    starter3: "Give me a verse about justice and explain it simply.",
    starter4: "How can I awaken consciences without offending?",
  },
  footer: {
    intro: "Art Director · Photographer · Web Designer · Layout Artist — Paris. The adviser Senegalese youth never had.",
    secTitle: "Security & privacy",
    secBody: "Papicoo never asks for your passwords or sensitive data. Your conversations stay in your space.",
    signature: "Design by Papicoo",
    privacy: "Privacy",
    cgu: "Terms",
    library: "Quran library",
  },
  meta: {
    title: "Papicoo — Quiet strength · AI assistant & services",
    description: "Papicoo: an AI assistant inspired by Papicoo, diaspora services, content studio, Quran and music. Paris — Dakar — The World.",
  },
  partial: "",
  quranFr: "Verse translations are shown in French: no verified English translation is available on this site yet.",
};

const ar = {
  nav: {
    accueil: "الرئيسية", services: "الخدمات", gp: "GP السنغال", transfert: "تحويل",
    boutique: "المتجر", chat: "الدردشة", live: "مباشر", studio: "الاستوديو", portrait: "صورة",
    evoto: "إيفوتو", decodeur: "فك الشيفرة", analyse: "تحليل", facebook: "فيسبوك",
    contrats: "العقود", coran: "القرآن", reseaux: "شبكاتي", papicoo: "بابيكو",
    cta: "تحدّث إلى بابيكو",
  },
  landing: {
    role: "مدير فني · مصور · مصمم ويب · رسام",
    title1: "بابيكو.",
    title2: "المستشار للشباب.",
    intro: "حاضر، عادل، راسخ في القرآن. محلل جيوسياسي وعلمي، مستشار تطوير المشاريع، وكالة تواصل، GP وتحويل للمغتربين — دون دعاية، دون احتيال، بكل اللغات.",
    cta1: "ابدأ محادثة",
    cta2: "من هو بابيكو؟",
    privacy: "الخصوصية محمية — لا يُطلب أي كلمة سر أبداً.",
    forceTranquille: "قوة هادئة",
    quote: "« لست إلا على ما اتبعه الأنبياء. »",
  },
  switcher: { label: "اللغة", fr: "Français", ar: "العربية", wo: "Wolof" },
  verset: {
    eyebrow: "آية اليوم · بابيكو",
    today: "اليوم",
    refresh: "تحديث",
    listen: "استمع إلى بابيكو (صوت إذاعة FM)",
    listening: "إيقاف مؤقت",
    preparing: "تحضير الاستوديو…",
    download: "تنزيل الصورة المربعة (1080×1080)",
    share: "شارك هذه البركة",
    surah: "سورة",
    verse: "آية",
    tomorrow: "عُد غداً لآية جديدة 🌹",
    loading: "جارٍ تحميل الآية…",
    title1: "نور كل يوم.",
    title2: "للمشاركة والتأمّل.",
    intro: "كل صباح، يقدّم لك بابيكو آية من القرآن مختارة بشكل ثابت بحسب تاريخ اليوم. حمّل الصورة المربّعة وشاركها على ستوريز إنستغرام، واتساب أو إكس.",
  },
  ramadan: {
    eyebrow: "رمضان 1447هـ · تقويم بابيكو",
    title1: "ثلاثون نوراً.",
    title2: "آية كل يوم.",
    intro: "اختيار قرآني متدرّج — عشرة بعشرة — لعبور الشهر المبارك بوضوح ولين. شارك آية اليوم، حمّل الصورة المربعة، وانثر البركة من حولك.",
    today: "اليوم · يوم {{day}} من رمضان",
    loading: "جارٍ تحميل التقويم…",
    decade1: "العشر الأول · الرحمة",
    decade2: "العشر الثاني · المغفرة",
    decade3: "العشر الثالث · العتق من النار",
    day: "يوم",
    image: "صورة 1080×1080",
    listen: "استمع إلى بابيكو (صوت إذاعة FM)",
    listening: "إيقاف مؤقت",
    preparing: "تحضير الاستوديو…",
  },
  coran: {
    eyebrow: "المكتبة القرآنية",
    title: "القرآن الكريم، حفص.",
    subtitle: "114 سورة · 6236 آية — نص فرنسي + بحث كامل.",
    search: "ابحث عن كلمة، موضوع، آية…",
  },
  chat: {
    welcome: "السلام عليكم. أنا بابيكو. اطرح سؤالك — جواب هادئ، متجذّر في القرآن.",
    placeholder: "اكتب رسالتك إلى بابيكو…",
    send: "إرسال",
    new: "محادثة جديدة",
    free: "أسئلة مجانية",
    paywallTitle: "استعملت الأسئلة المجانية الثلاثة.",
    paywallBody: "للمتابعة مع بابيكو، افتح الوصول غير المحدود.",
    paywallCta: "افتح الوصول",
    starter1: "السلام عليكم بابيكو، بماذا أبدأ لكسب رزقي بنزاهة؟",
    starter2: "كيف أحوّل صفحة فيسبوك إلى صفحة مهنية؟",
    starter3: "أعطني آية عن العدل واشرحها ببساطة.",
    starter4: "كيف أوقظ الضمائر دون إيذاء؟",
  },
  footer: {
    intro: "مدير فنّي · مصوّر · مصمّم ويب · مونتاج — باريس. المستشار الذي لم يكن للشباب السنغالي قطّ.",
    secTitle: "الأمان والخصوصية",
    secBody: "بابيكو لا يطلب أبداً كلمات السر أو البيانات الحساسة. تبقى محادثاتك في مساحتك الخاصة.",
    signature: "Design by Papicoo",
    privacy: "الخصوصية",
    cgu: "شروط الاستخدام",
    library: "مكتبة القرآن",
  },
  partial: "تنبيه: الترجمة العربية جزئية — بعض أجزاء هذه الصفحة ما زالت بالفرنسية.",
  quranFr: "ترجمات معاني الآيات معروضة بالفرنسية.",
};

const wo = {
  nav: {
    accueil: "Tagu", services: "Liggéey", gp: "GP Senegaal", transfert: "Yónnee xaalis",
    boutique: "Jaay", chat: "Wax", live: "Bu sax", studio: "Studio", portrait: "Nataal",
    evoto: "Évoto", decodeur: "Firi", analyse: "Xool", facebook: "Facebook",
    contrats: "Kontorat", coran: "Alxuraan", reseaux: "Sama Réseaux", papicoo: "Papicoo",
    cta: "Wax ak Papicoo",
  },
  landing: {
    role: "DA · NATAALKAT · WEB DESIGNER · MAQUETTISTE",
    title1: "Papicoo.",
    title2: "Jaambur bi waxtaan ndaw ñi.",
    intro: "Bii fii, jub, sukkandiku ci Alxuraan. Tasaarukatu jeexiit ak xam-xam, dëkkalkatu projet, soxlaak yu nataal, GP ak yónnee xaalis ngir diaspora gi — amul propaganda, amul nax, ci làkk yépp.",
    cta1: "Tambalee waxtaan",
    cta2: "Kan mooy Papicoo ?",
    privacy: "Sutura jëfë — kenn du la laaj mot de passe, mukk.",
    forceTranquille: "DOOLE BU TANE",
    quote: "« Manul lu dul li yónnent yi topp. »",
  },
  switcher: { label: "Làkk", fr: "Français", ar: "العربية", wo: "Wolof" },
  verset: {
    eyebrow: "LAYAA BU BËS · PAPICOO",
    today: "Tey",
    refresh: "Yeesalat",
    listen: "Dégg Papicoo di jàng (baat radio FM)",
    listening: "Taxaw",
    preparing: "Waajalu studio…",
    download: "Telesarjee xët bi (1080×1080)",
    share: "Séddoo barke bi",
    surah: "Sourate",
    verse: "laayaa",
    tomorrow: "Dellul ëllëg ngir bennen laayaa 🌹",
    loading: "Yónnee laayaa bi…",
    title1: "Bés bu nekk, leer.",
    title2: "Séddoo, sukkandiku.",
    intro: "Suba bu nekk, Papicoo dafa la jox ab laayaa ci Alxuraan, tànn ko ci tas-tasug bés bi. Telesarjee xët bi te séddoo ko ci sa Instagram, WhatsApp walla X.",
  },
  ramadan: {
    eyebrow: "RAMADAAN 1447H · TAKHAW PAPICOO",
    title1: "Fanweer leeram.",
    title2: "Bés bu nekk, benn laayaa.",
    intro: "Tanu laayaaki Alxuraan — fanweer-fanweer — ngir jaar weer wi tedd ak xel mu set ak laabir. Séddoo laayaa bu bés bi, telesarjee xët bi, te wallu barke bi ci sa réew.",
    today: "Tey · Bés bu {{day}} ci Ramadaan",
    loading: "Yónnee takhaw bi…",
    decade1: "Fanweeri 1 · Yërmaande (Rahma)",
    decade2: "Fanweeri 2 · Baal (Maghfira)",
    decade3: "Fanweeri 3 · Mucc safara (Itq min an-Nâr)",
    day: "Bés",
    image: "Xët 1080×1080",
    listen: "Dégg Papicoo di jàng (baat radio FM)",
    listening: "Taxaw",
    preparing: "Waajalu studio…",
  },
  coran: {
    eyebrow: "BIBLIOTEKK ALXURAAN",
    title: "Alxuraan, Hafs.",
    subtitle: "114 sourate · 6236 laayaa — bind frans + ceet bu fees.",
    search: "Ceet baat, suje, laayaa…",
  },
  chat: {
    welcome: "Saalaam aleykum. Maa ngi Papicoo. Laaj ma — tontu jamm, sukkandiku ci Alxuraan.",
    placeholder: "Bind sa mbind ngir Papicoo…",
    send: "Yónnee",
    new: "Bennen waxtaan",
    free: "Laaj yu free",
    paywallTitle: "Jëfandikoo nga ñetti laaj yi may.",
    paywallBody: "Ngir continue ak Papicoo, ubbi access bi du fees dara.",
    paywallCta: "Ubbi access",
    starter1: "Saalaam Papicoo, ci lan laay tambalee ngir am sama xaalis te yiw?",
    starter2: "Naka laa di defar sama page Facebook mu professionnel?",
    starter3: "Joxal ma benn laayaa ci njub te xamal ko ci yónn yu pas.",
    starter4: "Naka la nuy yee xel yi te suufalewu kenn?",
  },
  footer: {
    intro: "Direktëer Artistik · Nataalkat · Web Designer · Maquettiste — Paris. Jaambur bi ndaw senegaal gi wax wuñu am.",
    secTitle: "Kaaraange ak suturoo",
    secBody: "Papicoo du laaj benn baatu sutura walla saw data yu sensible. Sa waxtaani du génn sa boppam.",
    signature: "Design by Papicoo",
    privacy: "Suturoo",
    cgu: "Yoonu jëfandikoo",
    library: "Bibliotekk Alxuraan",
  },
  partial: "Xamal : tekki gi ci wolof matul — ay pàcc ci xët wii ñu ngi ci làkku tubaab (français) ba leegi.",
  quranFr: "Tekkib aaya yi ñu ngi ci làkku tubaab (français).",
};

const SUPPORTED = ["fr", "en", "ar", "wo"];
const stored = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
const initialLang = SUPPORTED.includes(stored) ? stored : "fr";

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en }, ar: { translation: ar }, wo: { translation: wo } },
  lng: initialLang,
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

const applyDocumentLang = (lng) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.title = i18n.t("meta.title");
  const desc = document.querySelector('meta[name="description"]');
  if (desc) desc.setAttribute("content", i18n.t("meta.description"));
};

applyDocumentLang(initialLang);

export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  if (typeof window !== "undefined") localStorage.setItem(STORAGE_KEY, lng);
  applyDocumentLang(lng);
};

export default i18n;
